// extracted by mini-css-extract-plugin
module.exports = {"additional":"support-styles-module--additional--3mPhP","button":"support-styles-module--button--ytNGd"};